<!--<ul>
<li *ngFor="let item of result">{{item.Title}}</li>
</ul>-->

<!--<div class="quick-action" [@quickAction]="quickActionState" [ngStyle]="{top: offsetTop}">

<a (click)="navigate(child)" class="add" *ngFor="let child of quickActionsItems | menuTypePipe:2">
  <div [ngStyle]="{'background-image': 'url(' + child.Icon + ')'}"></div>
</a>

</div>-->

<div class="sidebar" [@slideInOut]="menuState" (click)="parentClick()">

  <div class="logo-holder logo" (click)="toggleMenu($event)">

    <div [@componentTransform]="menuState" [ngStyle]="{'background-image': 'url(' + imgPath + ')'}" [class.open]="menuState == 'in'" [class.closed]="menuState == 'out'" class="img left-menu-logo-img">
      @if (opened == false) {
        <span class="tooltip-text">Glavni meni</span>
      }
    </div>
    <p [@itemTransform]="menuState"><a [innerHTML]="projectName"></a></p>

  </div>

  <div class="left-menu-wrapper">
    <div class="left-menu-nodes">
      <ng-scrollbar [visibility]="'hover'">
        @for (node of result; track node) {
          <div class="item-wrapper">
            @if (isRootLink(node)) {
              <div>
                <a (click)="navigate(node)">
                  <div [className]="containsSubItemsOfGroup(node.Children,1) && opened ? 'item main-node-item first-of-type dropdown' : 'item main-node-item first-of-type'"
                    (click)="itemClicked(node,$event)">
                    <div [@nodeImg]="menuState" class="node-container node-img">
                      <div [@Img]="menuState" class="left-menu-node-icon" style="background-image: url('/assets/project-custom/images/{{node.Icon}}')"></div>
                    </div>
                    <div class="node-container">
                      @if (opened == false) {
                        <span class="tooltip-text">{{node.TooltipText}}</span>
                      }
                      <p [@itemTransform]="menuState">{{translationsService.translate(node.OriginalTitle)}}</p>
                    </div>
                  </div>
                </a>
              </div>
            } @else {
              <div [className]="containsSubItemsOfGroup(node.Children,1) && opened ? 'item main-node-item first-of-type dropdown' : 'item main-node-item first-of-type'"
                (click)="itemClicked(node,$event, true)">
                <div [@nodeImg]="menuState" class="node-container node-img">
                  <div [@Img]="menuState" class="left-menu-node-icon" style="background-image: url('/assets/project-custom/images/{{node.Icon}}')"></div>
                </div>
                <div class="node-container">
                  @if (opened == false) {
                    <span class="tooltip-text">{{node.TooltipText}}</span>
                  }
                  <p [@itemTransform]="menuState">{{translationsService.translate(node.OriginalTitle)}}</p>
                </div>
              </div>
              <!-- NOT a template, just immediate rendering -->
              @if (containsSubItemsOfGroup(node.Children,1) && opened && node.Selected) {
                <div class="submenu">
                  <div class="hover-overlay"></div>
                  @for (child of getChildNodes(node.Children); track child) {
                    <div class="sub-item">
                      <a (click)="navigate(child)">
                        <p (click)="itemClicked(child,$event)"
                          [className]="(childPadding(child) ? 'node-child child-node-padding' : 'node-child')">
                          {{ translationsService.translate(child.OriginalTitle) }} @if (nodeContainsChildrenOfSameGroup(child, child.Children, 1)) {
                          <span class="dd-child-icon-arrow-down"></span>
                        }
                      </p>
                    </a>
                    <!-- Recursive call here -->
                    @if (containsSubItemsOfGroup(child.Children, 1)) {
                      <div>
                        <ng-template [ngTemplateOutlet]="submenu" [ngTemplateOutletContext]="{ node: child, paddinglvl: 15 }"></ng-template>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- Template for recursive submenu rendering -->
            <ng-template #submenu let-node="node" let-paddinglvl="paddinglvl">
              @if (node.Selected && opened) {
                <div class="submenu">
                  <div class="hover-overlay"></div>
                  @for (child of getChildNodes(node.Children); track child) {
                    <div class="sub-item">
                      <a (click)="navigate(child)">
                        <p (click)="itemClicked(child,$event)"
                          [ngStyle]="{ 'padding-left.px': 28 + paddinglvl }"
                          [className]="childPadding(child) ? 'node-child child-node-padding' : 'node-child'">
                          {{ translationsService.translate(child.OriginalTitle) }}
                        </p>
                      </a>
                      @if (containsSubItemsOfGroup(child.Children, 1)) {
                        <div>
                          <ng-template [ngTemplateOutlet]="submenu" [ngTemplateOutletContext]="{ node: child, paddinglvl: paddinglvl + 15  }"></ng-template>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </ng-template>
          }
        </div>
      }


    </ng-scrollbar>
  </div>


  @if (opened) {
    <div class="sub-sidebar">
      <div class="img-holder-sub-sidebar">
      </div>
    </div>
  }


</div>


</div>
